import { InspectionModel } from '../../inspection/model/inspection.model';
import { ModuleModel } from '../../module.model.interface';
// import { InspectionModel } from '../../inspection/model/inspection.model';

export enum InspectionEntryState {
  Created,
  Disputed,
  Justified,
  Accepted
}

export class InspectionEntryStateDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const InspectionEntryStateMap = {
  Created: new InspectionEntryStateDetail({ id: 'Created', name: 'Létrehozva' }),
  Disputed: new InspectionEntryStateDetail({ id: 'Disputed', name: 'Vitatva' }),
  Justified: new InspectionEntryStateDetail({ id: 'Justified', name: 'Indokolva' }),
  Accepted: new InspectionEntryStateDetail({ id: 'Accepted', name: 'Elfogadva' }),
};

export const InspectionEntryStateList: InspectionEntryStateDetail[] = [
  InspectionEntryStateMap.Created,
  InspectionEntryStateMap.Disputed,
  InspectionEntryStateMap.Justified,
  InspectionEntryStateMap.Accepted,
];

export class InspectionEntryDescriptor implements ModuleModel {
  public discriminator = 'InspectionEntryDescriptor';

  public id: string;
  public inspectionId: string;
  public dataEntryId: string;
  public reference: string;
  public technicalDescription: string;
  public publicDescription: string;
  public isTechnicalDescriptionVisible: boolean;
  public inspectionEntryState: InspectionEntryState;
  public stateDescription: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public inspectionDetail: InspectionModel;

  constructor(options?: {
    id: string;
    inspectionId: string;
    dataEntryId: string;
    reference: string;
    technicalDescription: string;
    publicDescription: string;
    isTechnicalDescriptionVisible: boolean;
    inspectionEntryState: InspectionEntryState;
    stateDescription: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.inspectionId = options.inspectionId;
      this.dataEntryId = options.dataEntryId;
      this.reference = options.reference;
      this.technicalDescription = options.technicalDescription;
      this.publicDescription = options.publicDescription;
      this.isTechnicalDescriptionVisible = options.isTechnicalDescriptionVisible;
      this.inspectionEntryState = options.inspectionEntryState;
      this.stateDescription = options.stateDescription;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/inspection.entry/model/inspection.entry.ts